import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { GestionesComponent } from './pages/gestiones/gestiones.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

const routes: Routes = [
  { path: 'errorpath', component: NotfoundComponent },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'gestionesab', component: GestionesComponent, canActivate: [AuthGuard] },
  { path: '',   redirectTo: 'gestiones/1', pathMatch: 'full' },
    { path: '**', component: GestionesComponent, canActivate: [AuthGuard] }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
